// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-toolbar[data-v-74dc04ca]{background:#fff;max-width:100vw;padding:0!important;transition:height 2s}.top-toolbar--dense[data-v-74dc04ca]{max-height:64px!important}.top-toolbar--transparent[data-v-74dc04ca]{box-shadow:none!important;transition:background-color .3s}.login--absolute[data-v-74dc04ca]{position:absolute;right:80px;top:22px;z-index:1}.business-page-btn[data-v-74dc04ca]{text-shadow:0 1px 8px hsla(0,0%,100%,.733)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
